<section
  formEnhance
  [callback]="search"
  [bindTo]="formBind"
  [primeNgDropdowns]="hasSearchDropDowns"
  [autoCompleteControls]="hasAutoCompleteControls"
  class="FIND_USERS"
>
  <div class="l-flex l-flex-wrap t-panel l-align-y">
    <input-wrap>
      <input
        class="t-input t-input-icon-search"
        type="text"
        [(ngModel)]="username"
        placeholder="{{ 'translate.general.username' | translate }}"
        (keypress)="onKeyPress($event)"
      />
    </input-wrap>
    <span class="spacer t-space--small"></span>
    <input-wrap [loading]="roleList && roleList.loading">
      <p-select
        #hasSearchDropdown
        [options]="roleList"
        optionLabel="label"
        [(ngModel)]="selectedRole"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.role' | translate"
        [filter]="true"
        [resetFilterOnHide]="true"
        name="selectedRole"
        (onChange)="onFieldValueChanged($event)"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedRole"
        (click)="selectedRole = null; search()"
      ></clear-multi>
    </input-wrap>
    <span class="spacer t-space--small"></span>
    <input-wrap [loading]="clinicList && clinicList.loading">
      <p-select
        #hasSearchDropdown
        [options]="clinicList"
        optionLabel="label"
        [(ngModel)]="selectedClinic"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.clinic' | translate"
        [filter]="true"
        [resetFilterOnHide]="true"
        name="selectedClinic"
        (onChange)="onFieldValueChanged($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedClinic"
        (click)="selectedClinic = null; search()"
      ></clear-multi>
    </input-wrap>
    <span class="spacer t-space--small"></span>
    <input-wrap [loading]="plantList && plantList.loading">
      <p-select
        #hasSearchDropdown
        [options]="plantList"
        optionLabel="label"
        [(ngModel)]="selectedPlant"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.plant' | translate"
        [filter]="true"
        [resetFilterOnHide]="true"
        name="selectedPlant"
        (onChange)="onFieldValueChanged($event)"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedPlant"
        (click)="selectedPlant = null; search()"
      ></clear-multi>
    </input-wrap>
    <span class="spacer t-space--small"></span>
    <button class="t-button t-button--flat" (click)="search()">
      {{ "translate.general.search" | translate }}
    </button>
    <span class="spacer t-space--small"></span>
    <button class="t-button-outline c-c1" (click)="onCreateUserClicked()">
      {{ "translate.users.createUser" | translate }}
    </button>
  </div>
</section>
